// @ts-nocheck
import React from 'react';
import useCountdown from 'crehana-react-hooks/useCountdown';

const Countdown: React.FC<{
  dueDate: Date;
}> = ({ dueDate }) => {
  const {
    rawDays,
    hours,
    minutes,
    seconds,
    hasStarted,
    finished,
  } = useCountdown(dueDate);

  if (!hasStarted || finished) return null;

  return (
    <React.Fragment>
      <div
        id="countdown-2"
        className="bg-base-light px-12 pt-12 pb-8 w-full rounded-5"
      >
        <p className="font-label text-white text-center">
          TERMINA EN {rawDays}d : {hours}h: {minutes}m: {seconds}s
        </p>
      </div>
    </React.Fragment>
  );
};

export default Countdown;
